import type { ModuleLanguage } from "../contract";

export const emoteSlotsCatalog = {
  de: {
    name: "Slot",
    description: "Drehe an den Walzen und knacke den Jackpot.",
    howToPlayParticipation: "Jeder Dreh wird sofort abgerechnet.",
    commands: { slot: "Dreht die Slot-Walzen für Punkte.", slotSyntax: "!slot [Einsatz]", stakeArgument: "Einsatz", stakeHint: "Punkteinsatz; ohne Angabe gilt der Standardeinsatz." },
    symbols: {
      cherry: "Kirsche",
      lemon: "Zitrone",
      bell: "Glocke",
      star: "Stern",
      diamond: "Diamant",
      seven: "Sieben",
    },
    chat: {
      pair: "{slot.symbols}  {slot.net} · Stand {slot.balance} · Jackpot {slot.jackpot}",
      pairRefund: "{slot.symbols}  Einsatz zurück · {slot.net} · Stand {slot.balance} · Jackpot {slot.jackpot}",
      win: "{slot.symbols}  {slot.net} · Stand {slot.balance} · Jackpot {slot.jackpot}",
      loss: "{slot.symbols}  {slot.net} · Stand {slot.balance} · Jackpot {slot.jackpot}",
      jackpot: "{slot.symbols}  JACKPOT! {user} gewinnt {slot.net} · Jackpot jetzt {slot.jackpot}",
      invalidStake: "Der Einsatz muss eine ganze Zahl zwischen {min} und {max} sein.",
      insufficient: "Du hast {balance} Punkte, ein Dreh kostet mindestens {min}. Punkte gibt es fürs Mitchatten.",
      cooldown: "Bitte warte noch {seconds} Sekunden bis zu deinem nächsten Dreh.",
    },
    panel: {
      ariaLabel: "Slot-Einstellungen",
      sections: { reels: "Walzen", stakes: "Einsätze", jackpot: "Jackpot", cooldown: "Abklingzeit", chat: "Chat-Ziel", texts: "Texte" },
      symbol: "Symbol",
      source: "Quelle",
      weight: "Gewicht",
      weightAria: "Gewicht {name}",
      countAvailable: "{count} Symbole verfügbar",
      countAvailableOne: "{count} Symbol verfügbar",
      emotesAvailable: "{count} Emotes verfügbar",
      emotesAvailableOne: "{count} Emote verfügbar",
      triple: "3 gleiche",
      tripleAria: "Gewinn bei 3 gleichen {name}",
      jackpotAria: "Jackpot-Symbol {name}",
      jackpotSymbol: "Jackpot-Symbol",
      jackpotRow: "Jackpot",
      jackpotCurrent: "Jackpot aktuell {amount}",
      chooseSymbol: "Symbol wählen",
      unsaved: "Ungespeichert",
      emoji: "Emoji",
      twitch: "Twitch",
      sevenTv: "7TV",
      loadingEmotes: "Emotes werden geladen …",
      emotesUnavailable: "Emotes sind gerade nicht verfügbar.",
      emotesReconnect: "Bot neu verbinden, um Twitch-Emotes zu laden.",
      sevenTvLoading: "7TV-Emotes werden geladen …",
      sevenTvActiveSet: (name: string) => `7TV · aktives Set: ${name}`,
      sevenTvNoAccount: "7TV: kein Konto zu diesem Kanal gefunden",
      sevenTvUnavailable: "7TV ist gerade nicht verfügbar.",
      sevenTvChatHint: "Ohne 7TV sieht der Chat den Emote-Code.",
      sevenTvMissing: "nicht im aktiven 7TV-Set",
      reconnect: "Bot neu verbinden",
      reconnectDialogTitle: "Twitch-Emotes freigeben",
      reconnectDialogDescription: "Das Bot-Konto muss sich erneut verbinden, damit es Twitch-Emotes für diesen Kanal laden kann. Bitte die Person mit Zugriff auf das Bot-Konto darum bitten.",
      reconnectDialogAuthorize: "Mit Bot-Konto verbinden",
      noEmotes: "Keine Emotes verfügbar.",
      minStake: "Mindesteinsatz",
      defaultStake: "Standardeinsatz",
      maxStake: "Höchsteinsatz",
      points: "Punkte",
      seed: "Startwert",
      share: "Anteil je Einsatz",
      pairPayout: "Auszahlung bei zwei gleichen Symbolen",
      pairPayoutHint: "Auszahlung als Vielfaches des Einsatzes; auf ganze Punkte abgerundet.",
      announce: "Jackpot als Twitch-Ankündigung",
      announceHint: "Ein Jackpot-Treffer wird im Stream hervorgehoben.",
      seconds: "s",
      cooldown: "Pause je Person",
      targetLabel: "Antworten senden an",
      whereAsked: "Dort antworten, wo gespielt wurde",
      sourceOnly: "Nur im Quellchat",
      allChats: "In allen Chats",
      win: "Gewinn",
      loss: "Verlust",
      pair: "Paar",
      jackpotText: "Jackpot",
      messageEnabledLabel: "Nachricht senden",
      messageOn: "An",
      messageOff: "Aus",
      messageMissing: "Text fehlt",
      insertVariable: "Variable einfügen",
      preview: "Vorschau",
      previewSpeaker: "BroBot",
      quote: "Auszahlungsquote",
      quoteInvalid: "Quote erst nach gültigen Werten",
      quoteTarget: "im Zielbereich (85–95 %)",
      quoteWarning: "außerhalb des Zielbereichs (85–95 %)",
      quoteLocked: "über 100 %: Speichern gesperrt",
      quoteFieldError: "Hebt die Quote über 100 % – Wert senken",
      quoteLockedReason: "Die Auszahlungsquote muss unter 100 % liegen.",
      weightError: "Ganze Zahl von 1 bis 99.",
      tripleError: "Ganze Zahl von 2 bis 500.",
      minStakeError: "Ganze Zahl von 1 bis 10.000.",
      defaultStakeError: "Ganze Zahl von 1 bis 100.000.",
      maxStakeError: "Ganze Zahl von 1 bis 100.000.",
      seedError: "Ganze Zahl von 0 bis 1.000.000.",
      shareError: "Schritte von 0,01 % zwischen 0 und 20 % eingeben.",
      pairPayoutError: "Faktor von 1 bis 3 mit höchstens vier Nachkommastellen eingeben.",
      cooldownError: "Ganze Zahl von 0 bis 3.600 Sekunden.",
      minimumExceedsMaximum: "Mindesteinsatz darf den Höchsteinsatz nicht überschreiten.",
      defaultOutsideStakeRange: "Standardeinsatz muss zwischen Mindest- und Höchsteinsatz liegen.",
      duplicateSymbol: "Jedes Symbol darf nur einmal vorkommen.",
      jackpotRequired: "Wähle genau ein Jackpot-Symbol.",
      picker: {
        title: "Slot-Symbol wählen",
        searchLabel: "Emoji, Twitch- oder 7TV-Emote suchen",
        closeLabel: "Symbolauswahl schließen",
        noResults: "Keine passenden Symbole.",
        navigate: "Navigieren",
        choose: "Auswählen",
        close: "Schließen",
      },
      variables: {
        user: "Name der spielenden Person",
        symbols: "Gezogene Slot-Symbole",
        net: "Nettogewinn oder -verlust",
        balance: "Kontostand nach dem Dreh",
        jackpot: "Jackpot nach dem Dreh",
        payout: "Auszahlung vor Abzug des Einsatzes",
        stake: "Einsatz des Drehs",
      },
    },
  },
  en: {
    name: "Slot",
    description: "Spin the reels and hit the jackpot.",
    howToPlayParticipation: "Each spin settles immediately.",
    commands: { slot: "Spins the slot reels for points.", slotSyntax: "!slot [stake]", stakeArgument: "stake", stakeHint: "Point stake; uses the default stake when omitted." },
    symbols: {
      cherry: "Cherry",
      lemon: "Lemon",
      bell: "Bell",
      star: "Star",
      diamond: "Diamond",
      seven: "Seven",
    },
    chat: {
      pair: "{slot.symbols}  {slot.net} · Balance {slot.balance} · Jackpot {slot.jackpot}",
      pairRefund: "{slot.symbols}  Stake back · {slot.net} · Balance {slot.balance} · Jackpot {slot.jackpot}",
      win: "{slot.symbols}  {slot.net} · Balance {slot.balance} · Jackpot {slot.jackpot}",
      loss: "{slot.symbols}  {slot.net} · Balance {slot.balance} · Jackpot {slot.jackpot}",
      jackpot: "{slot.symbols}  JACKPOT! {user} wins {slot.net} · Jackpot now {slot.jackpot}",
      invalidStake: "Your stake must be a whole number between {min} and {max}.",
      insufficient: "You have {balance} points; a spin costs at least {min}. Earn points by chatting.",
      cooldown: "Please wait {seconds} seconds before your next spin.",
    },
    panel: {
      ariaLabel: "Slot settings",
      sections: { reels: "Reels", stakes: "Stakes", jackpot: "Jackpot", cooldown: "Cooldown", chat: "Chat target", texts: "Messages" },
      symbol: "Symbol",
      source: "Source",
      weight: "Weight",
      weightAria: "Weight {name}",
      countAvailable: "{count} symbols available",
      countAvailableOne: "{count} symbol available",
      emotesAvailable: "{count} emotes available",
      emotesAvailableOne: "{count} emote available",
      triple: "3 alike",
      tripleAria: "Payout for 3 matching {name}",
      jackpotAria: "Jackpot symbol {name}",
      jackpotSymbol: "Jackpot symbol",
      jackpotRow: "Jackpot",
      jackpotCurrent: "Current jackpot {amount}",
      chooseSymbol: "Choose symbol",
      unsaved: "Unsaved",
      emoji: "Emoji",
      twitch: "Twitch",
      sevenTv: "7TV",
      loadingEmotes: "Loading emotes …",
      emotesUnavailable: "Emotes are currently unavailable.",
      emotesReconnect: "Reconnect the bot to load Twitch emotes.",
      sevenTvLoading: "Loading 7TV emotes …",
      sevenTvActiveSet: (name: string) => `7TV · active set: ${name}`,
      sevenTvNoAccount: "7TV: no account found for this channel",
      sevenTvUnavailable: "7TV is currently unavailable.",
      sevenTvChatHint: "Without 7TV, chat sees the emote code.",
      sevenTvMissing: "not in the active 7TV set",
      reconnect: "Reconnect bot",
      reconnectDialogTitle: "Authorize Twitch emotes",
      reconnectDialogDescription: "The bot account needs to reconnect so it can load Twitch emotes for this channel. Ask someone with access to the bot account to do this.",
      reconnectDialogAuthorize: "Connect as the bot account",
      noEmotes: "No emotes available.",
      minStake: "Minimum stake",
      defaultStake: "Default stake",
      maxStake: "Maximum stake",
      points: "Points",
      seed: "Seed amount",
      share: "Share per spin",
      pairPayout: "Payout for two matching symbols",
      pairPayoutHint: "Payout as a multiple of the stake, rounded down to whole points.",
      announce: "Announce jackpots on Twitch",
      announceHint: "A jackpot hit is highlighted on stream.",
      seconds: "s",
      cooldown: "Cooldown per person",
      targetLabel: "Send replies to",
      whereAsked: "Where the spin was played",
      sourceOnly: "Source chat only",
      allChats: "All chats",
      win: "Win",
      loss: "Loss",
      pair: "Pair",
      jackpotText: "Jackpot",
      messageEnabledLabel: "Send message",
      messageOn: "On",
      messageOff: "Off",
      messageMissing: "Text missing",
      insertVariable: "Insert variable",
      preview: "Preview",
      previewSpeaker: "BroBot",
      quote: "Payout rate",
      quoteInvalid: "Quote available after entering valid values",
      quoteTarget: "in target range (85–95%)",
      quoteWarning: "outside target range (85–95%)",
      quoteLocked: "over 100%: saving locked",
      quoteFieldError: "Raises the rate above 100% — lower this value",
      quoteLockedReason: "The payout rate must be below 100%.",
      weightError: "Whole number from 1 to 99.",
      tripleError: "Whole number from 2 to 500.",
      minStakeError: "Whole number from 1 to 10,000.",
      defaultStakeError: "Whole number from 1 to 100,000.",
      maxStakeError: "Whole number from 1 to 100,000.",
      seedError: "Whole number from 0 to 1,000,000.",
      shareError: "Use 0.01% steps between 0 and 20%.",
      pairPayoutError: "Enter a multiplier from 1 to 3 with at most four decimals.",
      cooldownError: "Whole number from 0 to 3,600 seconds.",
      minimumExceedsMaximum: "The minimum stake must not exceed the maximum stake.",
      defaultOutsideStakeRange: "The default stake must be between the minimum and maximum.",
      duplicateSymbol: "Each symbol can only appear once.",
      jackpotRequired: "Choose exactly one jackpot symbol.",
      picker: {
        title: "Choose a slot symbol",
        searchLabel: "Search emoji, Twitch or 7TV emotes",
        closeLabel: "Close symbol picker",
        noResults: "No matching symbols.",
        navigate: "Navigate",
        choose: "Choose",
        close: "Close",
      },
      variables: {
        user: "Name of the player",
        symbols: "Slot symbols drawn",
        net: "Net win or loss",
        balance: "Balance after the spin",
        jackpot: "Jackpot after the spin",
        payout: "Payout before the stake is deducted",
        stake: "Spin stake",
      },
    },
  },
} satisfies Readonly<Record<ModuleLanguage, object>>;

